(() => {
  function init() {
    const pages = Array.from(document.querySelectorAll('.uf-sp-page'));
    if (!pages.length || pages[0].dataset.ready) return;
    pages.forEach(page => page.dataset.ready = 'true');
    const root = document;
    const visual = root.querySelector('.hero-visual');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const descriptions = Array.from(root.querySelectorAll('[data-hero-phase]')).map(b => b.dataset.description) || [];
    const controls = root.querySelectorAll('.motion-control');
    const regions = root.querySelectorAll('.motion-region');
    const visibility = new Map();
    let phaseIndex = 3;
    let timer;
    let userPaused = false;
    let heroVisible = false;
    let started = false;
    let processTimer;
    let processTick=0;
    const processRegion=root.querySelector('#approach');
    function scheduleProcess(){
      clearTimeout(processTimer);
      if(reduced.matches){root.querySelector('[data-process-score]').textContent='99';root.querySelector('[data-process-score]').dataset.band='high';return;}
      if(userPaused || document.hidden || !visibility.get(processRegion))return;
      processTimer=setTimeout(()=>{
        processTick=(processTick+100)%6400;
        const progress=Math.min(1,Math.max(0,(processTick-800)/3200));
        const score=Math.round(42+57*progress);
        const counter=root.querySelector('[data-process-score]');
        counter.textContent=String(score);
        counter.dataset.band=score<50?'low':score<90?'mid':'high';
        scheduleProcess();
      },100);
    }

    function setPhase(index) {
      phaseIndex = index;
      visual.dataset.phase = String(index);
      const phaseButton = visual.querySelector('[data-hero-phase="' + index + '"]');
      visual.querySelector('[data-score]').textContent = phaseButton?.dataset.score || [42,42,86,99][index];
      visual.querySelector('[data-revenue]').textContent = phaseButton?.dataset.revenue || (index >= 2 ? '+30–50%' : '—');
      visual.querySelectorAll('[data-hero-phase]').forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
      visual.querySelectorAll('.hero-steps li').forEach((step, n) => {
        step.classList.toggle('current', n === index);
        step.classList.toggle('complete', n < index);
        if (n === index) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      visual.querySelector('.sequence-description').textContent = descriptions[index] || visual.querySelector('[data-hero-phase="' + index + '"]')?.dataset.description || '';
    }
    function schedule() {
      clearTimeout(timer);
      if (reduced.matches || userPaused || document.hidden || !heroVisible) return;
      timer = setTimeout(() => {
        setPhase((phaseIndex + 1) % 4);
        schedule();
      }, phaseIndex === 3 ? 3000 : 2400);
    }
    function updateMotion() {
      const paused = userPaused || reduced.matches;
      pages.forEach(page => page.dataset.motionPaused = String(paused));
      controls.forEach(button => {
        button.setAttribute('aria-pressed', String(userPaused));
        button.setAttribute('aria-label', userPaused ? 'Resume animations' : 'Pause animations');
        button.querySelector('span').textContent = userPaused ? 'Play motion' : 'Pause motion';
      });
      regions.forEach(region => {
        region.dataset.motionVisible = String(Boolean(visibility.get(region)) && !document.hidden);
      });
      if (reduced.matches) setPhase(3);
      schedule();
      scheduleProcess();
    }
    controls.forEach(button => button.addEventListener('click', () => {
      userPaused = !userPaused;
      updateMotion();
    }));
    visual.querySelectorAll('[data-hero-phase]').forEach(button => button.addEventListener('click', () => {
      setPhase(Number(button.dataset.heroPhase));
      schedule();
    }));
    reduced.addEventListener('change', updateMotion);
    document.addEventListener('visibilitychange', updateMotion);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === visual) {
            heroVisible = entry.isIntersecting;
            if (heroVisible && !started && !reduced.matches) {
              started = true;
              setPhase(0);
            }
          } else visibility.set(entry.target, entry.isIntersecting);
        });
        updateMotion();
      }, { threshold: 0.08 });
      observer.observe(visual);
      regions.forEach(region => observer.observe(region));
    } else {
      heroVisible = true;
      regions.forEach(region => visibility.set(region, true));
      if (!reduced.matches) setPhase(0);
    }
    updateMotion();

    root.querySelector('.character-replay')?.addEventListener('click',()=>{
      processTick=0;
      root.querySelectorAll('.process-step').forEach(panel=>{
        panel.classList.add('replaying');
        requestAnimationFrame(()=>requestAnimationFrame(()=>panel.classList.remove('replaying')));
      });
      userPaused=false; updateMotion();
    });
    root.querySelectorAll('.evaluate-item').forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        const layerVisual=root.querySelector('.layer-visual'); if(layerVisual) layerVisual.dataset.layer = detail.dataset.select;
        root.querySelectorAll('.evaluate-item').forEach(other => {
          if (other !== detail) other.open = false;
        });
      });
    });
    root.querySelectorAll('[data-pending-capability]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        root.querySelector('.related-status').textContent = link.querySelector('h3').textContent +
          ' — this page will be connected when the new Ultrafade site is ready.';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', () => { document.querySelectorAll('.uf-sp-page').forEach(p=>delete p.dataset.ready); init(); });
})();
